import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
              关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              {aboutData.title}
            </h2>
          </div>

          <div className="space-y-6">
            {aboutData.sections.map((section) => (
              <div key={section.subtitle} className="bg-background-100 rounded-lg p-6">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                  {section.subtitle}
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}